module.exports = __webpack_public_path__ + "static/img/robo.f9a0922.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/iconos/svg/robo.svg
// module id = jmJK
// module chunks = 1